/**
 * @generated SignedSource<<6b2c1c4764778aa56937948743423389>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespDealerDetails_user$data = {
  readonly isVerifiedTrade: boolean | null;
  readonly " $fragmentSpreads": FragmentRefs<"ContactDealerInlineForm_user" | "PdpSharedCallDealerCta_user" | "PdpSharedDealerDetailsHeader_user" | "PdpSharedSellerTabsVariant_user">;
  readonly " $fragmentType": "PdpRespDealerDetails_user";
};
export type PdpRespDealerDetails_user$key = {
  readonly " $data"?: PdpRespDealerDetails_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespDealerDetails_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespDealerDetails_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isVerifiedTrade",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ContactDealerInlineForm_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedSellerTabsVariant_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedCallDealerCta_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedDealerDetailsHeader_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "ce0bb90133657cec834f3cf3f9d9a9e1";

export default node;
